import React, { useState } from 'react';
import { getAlertsSummaryData } from '@api/eco2Alerts';
import { message } from 'antd';

export function useSummaryHook() {
  // original alert table data
  const [originalDataSource, setOriginalDataSource] = useState([]);
  // table loading
  const [loading, setLoading] = useState(true);
  // all candidate metrics
  const [allMetricList, setAllMetricList] = useState<string[]>([]);

  const fetchData = async (timeInterval) => {
    try {
      setLoading(true);
      const data = await getAlertsSummaryData({
        params: {
          from: timeInterval[0].utc().format().replace('T', ' ').replace('Z', ''),
          to: timeInterval[1].utc().format().replace('T', ' ').replace('Z', ''),
        },
      });
      const originalData = data.data;
      setOriginalDataSource(originalData);
      // set all metric list
      setAllMetricList([...new Set(originalData.map((row) => row.metrics))] as string[]);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setOriginalDataSource([]);
      message.error('API Error');
    }
  };

  return {
    fetchData,
    originalDataSource,
    loading,
    allMetricList,
  };
}
